import React from "react";
import "../styles/rarity.css";
import NFT from "../data/nft.jsx";

const Rarity = () => {
  
  return (
    <section className="rarity" id="rarity">
      <div className="mobile">
        <h1 className="title">Rarity</h1>
        <div className="options">
          {" "}
          <select name="rarity" id="">
            <option className="tag">Background</option>
            <option className="tag">Fur</option>
            <option className="tag">Eyes</option>
            <option className="tag">EyeWear</option>
            <option className="tag">Clothes</option>
            <option className="tag">Head</option>
            <option className="tag">Mouths</option>
          </select>
          <hr />

        </div>
        <div className="random">
          {NFT &&
            NFT.map((nft) => (
              <div className="nft" key={nft.id}>
                <img loading="lazy" src={nft.image} alt="nft_image" />
                <p className="nft_title">{nft.title}</p>
                <p className="nft_number">{nft.number}</p>
              </div>
            ))}
        </div>
      </div>
      <div className="desktop">
        <h1 className="title">Rarity</h1>
        <div className="options">
          <div className="option_names">
          <option className="tag">Background</option>
            <option className="tag">Fur</option>
            <option className="tag">Eyes</option>
            <option className="tag">EyeWear</option>
            <option className="tag">Clothes</option>
            <option className="tag">Head</option>
            <option className="tag">Mouths</option>
          </div>
          <hr />
        </div>
        <div className="random">
          {NFT &&
            NFT.map((nft) => (
              <div className="nft" key={nft.id}>
                <img loading="lazy" src={nft.image} alt="nft_image" />
                <p className="nft_title">{nft.title}</p>
                <p className="nft_number">{nft.number}</p>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Rarity;
